/* ============================================================
   D!FFERENT — Shopify theme interactions & motion
   Lenis (smooth scroll) + GSAP/ScrollTrigger + vanilla UI
   Stores are rendered by Liquid; JS only wires behaviour.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Carousels ---------- */
  function initCarousels(){
    document.querySelectorAll('[data-carousel]').forEach(function(car){
      var track = car.querySelector('.track');
      var counter = car.querySelector('.counter');
      var slides = car.querySelectorAll('.slide');
      var total = slides.length;
      if(!track || !total) return;
      function step(){ return slides[0] ? slides[0].getBoundingClientRect().width + 12 : 300; }
      function update(){
        var i = Math.round(track.scrollLeft / step());
        i = Math.max(0, Math.min(total-1, i));
        if(counter) counter.textContent = (i<9?'0':'')+(i+1)+' / '+(total<10?'0':'')+total;
      }
      track.addEventListener('scroll', function(){ window.requestAnimationFrame(update); }, {passive:true});
      var prev = car.querySelector('[data-prev]'), next = car.querySelector('[data-next]');
      if(next) next.addEventListener('click', function(){ track.scrollBy({left:step(), behavior:'smooth'}); });
      if(prev) prev.addEventListener('click', function(){ track.scrollBy({left:-step(), behavior:'smooth'}); });
      var down=false, sx=0, sl=0, moved=false;
      track.addEventListener('pointerdown', function(e){ down=true; moved=false; sx=e.clientX; sl=track.scrollLeft; track.classList.add('dragging'); });
      window.addEventListener('pointermove', function(e){ if(!down) return; var dx=e.clientX-sx; if(Math.abs(dx)>4) moved=true; track.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function(){ if(!down) return; down=false; track.classList.remove('dragging'); });
      track.addEventListener('click', function(e){ if(moved){ e.preventDefault(); } }, true);
    });
  }

  /* ---------- Accordion ---------- */
  function initPillars(){
    var pillars = Array.prototype.slice.call(document.querySelectorAll('.pillar'));
    var img = document.querySelector('[data-about-img]');
    var cap = document.querySelector('[data-about-cap]');
    var wrap = document.querySelector('.about__img');
    pillars.forEach(function(p){
      p.addEventListener('click', function(){
        if(p.classList.contains('is-open')) return;
        pillars.forEach(function(o){ o.classList.remove('is-open'); var ic=o.querySelector('.icon'); if(ic) ic.textContent='+'; });
        p.classList.add('is-open'); var pic=p.querySelector('.icon'); if(pic) pic.textContent='−';
        if(img && p.getAttribute('data-img')){
          var src = p.getAttribute('data-img');
          if(wrap) wrap.classList.add('swapping');
          window.setTimeout(function(){
            img.src = src;
            if(cap && p.getAttribute('data-cap')) cap.innerHTML = p.getAttribute('data-cap');
            if(wrap) wrap.classList.remove('swapping');
          }, 260);
        }
      });
    });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu(){
    var menu = document.querySelector('[data-menu]');
    if(!menu) return;
    document.querySelectorAll('[data-menu-open]').forEach(function(b){ b.addEventListener('click', function(){ menu.classList.add('open'); document.body.style.overflow='hidden'; }); });
    document.querySelectorAll('[data-menu-close]').forEach(function(b){ b.addEventListener('click', function(){ menu.classList.remove('open'); document.body.style.overflow=''; }); });
  }

  /* ---------- Newsletter (Shopify form handles submit) ---------- */
  function initForm(){
    document.querySelectorAll('[data-form]').forEach(function(form){
      // If Shopify already returned a success state, mark done.
      var sec = form.closest('.circle');
      if(sec && sec.getAttribute('data-posted') === 'success'){ sec.classList.add('done'); }
    });
  }

  /* ---------- Nav condense ---------- */
  function initNav(){
    var nav = document.querySelector('[data-nav]');
    if(!nav) return;
    function on(){ if(window.scrollY>60) nav.classList.add('scrolled'); else nav.classList.remove('scrolled'); }
    window.addEventListener('scroll', on, {passive:true}); on();
  }

  /* ---------- Motion (GSAP + Lenis) ---------- */
  function initMotion(){
    var hasGSAP = !!window.gsap;
    var lenis = null;
    if(window.Lenis){
      lenis = new window.Lenis({ lerp:0.09, smoothWheel:true });
      function raf(t){ lenis.raf(t); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
    }
    document.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var id=a.getAttribute('href'); if(id.length<2) return;
        var target=document.querySelector(id); if(!target) return;
        e.preventDefault();
        if(lenis) lenis.scrollTo(target, {duration:1.1}); else target.scrollIntoView({behavior:'smooth'});
      });
    });

    if(!hasGSAP) return;
    document.documentElement.classList.add('js');
    var gsap=window.gsap;
    if(window.ScrollTrigger){ gsap.registerPlugin(window.ScrollTrigger); if(lenis) lenis.on('scroll', window.ScrollTrigger.update); }

    if(document.querySelector('.hero__title')){
      gsap.timeline({ delay:0.15 })
        .from('.hero__title .line span', { yPercent:110, duration:1.15, ease:'expo.out', stagger:0.12 })
        .from('.hero .eyebrow, .hero__sub', { opacity:0, y:24, duration:0.9, ease:'power3.out', stagger:0.1 }, 0.35)
        .from('.hero__foot > *', { opacity:0, y:16, duration:0.8, ease:'power2.out', stagger:0.1 }, 0.6);
    }

    if(window.ScrollTrigger){
      gsap.utils.toArray('[data-reveal]').forEach(function(node){
        gsap.to(node, { opacity:1, y:0, duration:1, ease:'power3.out', scrollTrigger:{ trigger:node, start:'top 86%' } });
      });
      gsap.utils.toArray('[data-parallax]').forEach(function(node){
        var f = parseFloat(node.getAttribute('data-parallax'))||0.1;
        gsap.to(node, { yPercent:f*100, ease:'none', scrollTrigger:{ trigger:node.closest('section')||node, start:'top bottom', end:'bottom top', scrub:true } });
      });
    }

    var track = document.querySelector('[data-marquee]');
    if(track){
      var mq = gsap.to(track, { xPercent:-50, duration:22, ease:'none', repeat:-1 });
      if(lenis){
        lenis.on('scroll', function(e){
          mq.timeScale(Math.min(4, 1 + Math.abs(e.velocity||0)*0.25));
          gsap.to(mq, { timeScale:1, duration:0.6, overwrite:true });
        });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function(){
    initCarousels(); initPillars(); initMenu(); initForm(); initNav(); initMotion();
  });
})();
